import { useEffect } from 'react';

const _FONT_FAMILY = 'Inter, sans-serif';
const _FONT_WEIGHT_AXIS = 600;
const _FONT_WEIGHT_LABELS = 500;
const _FONT_SIZE_AXIS = 12;

export const chartBaseJsonConfig = {
  // Define base config as a function to easily merge with specific settings
  applyBaseConfig: (specificSettings) => {
    const baseConfig = {
      // Base styling applied to all charts
      chart: {
        fontFamily: "SF Pro Display, sans-serif",
        background: {
          fill: "#fff"
        }
      },
      title: {
        fontSize: 14,
        fontColor: "#333",
        fontWeight: '600',
        fontFamily: "SF Pro Display, sans-serif",
        text: ''
      },
      xAxis: {
        labels: {
          fontColor: "#333",
          fontSize: 10,
          fontWeight: '700',
          fontFamily: 'var(--font-title)'
        },
        stroke: "#e0e0e0"
      },
      yAxis: {
        labels: {
          fontColor: "#333",
          fontSize: 10,
          fontWeight: '700',
          fontFamily: 'var(--font-title)'
        },
        stroke: "#e0e0e0"
      }
    };

    // Merge base config with specific settings, allowing overrides
    return {
      ...baseConfig,
      ...specificSettings,
      xAxis: {
        ...baseConfig.xAxis,
        ...specificSettings.xAxis,
        labels: {
          ...baseConfig.xAxis.labels,
          ...specificSettings.xAxis?.labels
        }
      },
      yAxis: {
        ...baseConfig.yAxis,
        ...specificSettings.yAxis,
        labels: {
          ...baseConfig.yAxis.labels,
          ...specificSettings.yAxis?.labels
        }
      }
    };
  }
};


export const scatterConfigJson = {
  apply: (config)=>{
    return {
      xGrid: {
        enabled: true,
        stroke: '#e5e5e5'
      },
      xMinorGrid: {
        enabled: true,
        stroke: '#f1f1f1'
      },
      yGrid: {
        enabled: true,
        stroke: '#e5e5e5'
      },
      yMinorGrid: {
        enabled: true,
        stroke: '#f1f1f1'
      },
        labels: {
          enabled: config?.showLabels ?? true, // Enable labels for markers
          format: "{%name}", // Assuming 'Value' is the field in your data items
          position: "top", // Set the position of labels
          fontSize: 13, // Font size of the labels
          fontColor: "#4E6574", // Font color of the labels
          fontFamily: "Inter, sans-serif", // Font family of the labels
          offsetY: 15,
          fontWeight: '600'

      }
    }
  }
}




const applyAnychartStyles = (chart) => {
    if (!chart || !chart?.xAxis()) return;



    // Apply styles to the x-axis
    chart.xAxis().labels()
      .fontFamily(_FONT_FAMILY)
      .fontColor('#000')
      .fontWeight(_FONT_WEIGHT_LABELS)
        .fontSize(_FONT_SIZE_AXIS);

    chart.xAxis().title()
      .fontFamily(_FONT_FAMILY)
      .fontColor('#000')
      .fontWeight(_FONT_WEIGHT_AXIS);

    // Apply styles to the y-axis
    chart.yAxis().labels()
      .fontFamily(_FONT_FAMILY)
      .fontColor('#000')
      .fontWeight(_FONT_WEIGHT_LABELS)
        .fontSize(_FONT_SIZE_AXIS);

    chart.yAxis().title()
      .fontFamily(_FONT_FAMILY)
      .fontColor('#000')
      .fontWeight(_FONT_WEIGHT_AXIS);

    // Set grid line color
    chart?.grid?.().stroke('#ededed');

    // Set border and axis line colors
    chart.xAxis().stroke('#ededed');
    chart.yAxis().stroke('#ededed');

    // Apply similar styles to the legend
    chart.legend()
        .fontFamily(_FONT_FAMILY)
        .fontColor('#000')
        .fontWeight(500);

    // Apply tooltip styles
    chart.tooltip()
        .fontFamily(_FONT_FAMILY)
        .fontColor('#000')
        .fontWeight(_FONT_WEIGHT_LABELS);

};

export default applyAnychartStyles;



export const anystockPercentagePlotConfig = {
    yScale: 'percent',
    yLabelPostfix: '%',
    legend: {
        format: "%",
        precision: 2
    },
}
